import React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import ActiveFilter from "components/common/EntityFilters/ActiveFilter";
import HoverForHelp from "components/common/HoverForHelp";
import { ROW_MIN_HEIGHT } from "components/common/EntityFilters/Constants";
const FilterGroup = styled.div(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    min-height: ${ROW_MIN_HEIGHT}px;
    gap: ${theme.spacings.xxs};
    flex-wrap: wrap;

    &:not(:last-child) {
      margin-right: ${theme.spacings.xs};
    }
  `
);
const FilterGroupTitle = styled.div(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacings.xxs};
  `
);
const ActiveFilters = ({
  attributes,
  filters,
  filterValueRenderers,
  onDeleteFilter,
  onChangeFilter,
  activeSliceCol = void 0,
  activeSlice = void 0
}) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, filters.entrySeq().map(([attributeId, filterValues]) => {
    const attribute = attributes == null ? void 0 : attributes.find(({ id }) => id === attributeId);
    const isConflictingAttribute = !!activeSliceCol && !!activeSlice && activeSliceCol === attributeId;
    return /* @__PURE__ */ React.createElement(FilterGroup, { key: attributeId }, /* @__PURE__ */ React.createElement(FilterGroupTitle, null, /* @__PURE__ */ React.createElement("span", null, attribute.title, ":"), isConflictingAttribute && /* @__PURE__ */ React.createElement(HoverForHelp, { title: t("filters.filter_ignored"), pullRight: false }, t("filters.slice_conflict"))), filterValues.map((filter) => /* @__PURE__ */ React.createElement(
      ActiveFilter,
      {
        filter,
        allActiveFilters: filters,
        key: `${attribute.id}-${filter.value}`,
        attribute,
        filterValueRenderer: filterValueRenderers == null ? void 0 : filterValueRenderers[attributeId],
        onChangeFilter,
        onDeleteFilter,
        isConflicting: isConflictingAttribute
      }
    )));
  }).toArray());
};
export default ActiveFilters;
